import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

require('./foundation')

// instance property
window.Vue.prototype.$locale = {
    type: 'consul',
    appName: 'YOKUMIRU',
    appNameJa: 'ヨクミル',
    patient: '会員',
    consultation: '医療相談',
    consultation_host: '相談',
    consultation_guest: '相談',
    question: '相談内容',
}

/**
 * Add Quill.js divider module
 *
 * @see https://quilljs.com/guides/cloning-medium-with-parchment/#dividers
 * @see https://github.com/surmon-china/vue-quill-editor#register-quill-module
 * @see https://github.com/quilljs/quill/issues/1099#issuecomment-258560326
 */
import Quill from 'quill'
const icons = Quill.import('ui/icons')
icons['divider'] = '<svg class="icon" style="vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path class="ql-fill" d="M64 464h896v96H64v-96zM224 96v160h576V96h96v256H128V96h96z m576 832v-160H224v160H128v-256h768v256h-96z"></path></svg>'
const BlockEmbed = Quill.import('blots/block/embed')
class DividerBlot extends BlockEmbed { }
DividerBlot.blotName = 'divider'
DividerBlot.tagName = 'hr'
Quill.register(DividerBlot)

// vue-router
const routes = [];
const router = new VueRouter({
    mode: 'history',
    routes,
})

// create instance
const app = new Vue({
    el: '#app',
    store,
    router,
})
